<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
  <g>
    <rect width="16" height="16" fill="none"/>
    <polygon class="filled" points="13.203 6.875 9.125 6.875 9.125 2.797 6.875 2.797 6.875 6.875 2.797 6.875 2.797 9.125 6.875 9.125 6.875 13.203 9.125 13.203 9.125 9.125 13.203 9.125 13.203 6.875" fill="#035ce0"/>
  </g>
</svg>
